<template>
  <div class="home-container">
    <el-card class="el-card-d" shadow="always">
      <div class="infinite-list-wrapper" style="overflow:auto;">
        <p class="p22">免责声明 </p>
        <p class="p22">尊敬的用户，感谢您选择使用本网站。在使用本网站及其内容之前，请您务必仔细阅读以下免责声明。 </p>
        <p class="p22"> 一、内容来源声明 </p>
        <p class="p22">本网站所展示的图片和视频内容均来源于网络或其他用户上传，我们尽力确保所展示内容的合法性和合规性。然而，由于网络信息的复杂性和多样性，我们无法对每一张图片和每一段视频进行逐一核实。因此，对于因内容来源问题而引发的任何争议或法律责任，本网站不承担任何责任。 </p>
        <p class="p22">二、版权声明 </p>
        <p class="p22">本网站尊重他人的知识产权，我们已采取相应措施确保所展示的图片和视频内容不侵犯任何第三方的版权。但如果您发现本网站上有任何侵犯您或他人版权的内容，请您立即向我们反馈，我们将尽快进行处理。 </p>
        <p class="p22">三、内容真实性声明 </p>
        <p class="p22">尽管我们已尽力筛选和审核所展示的图片和视频内容，但无法保证其完全真实、准确或完整。用户在使用本网站内容时，应自行判断其真实性和准确性，并承担因使用不当而引发的任何风险。</p>
        <p class="p22">四、使用限制声明 </p>
        <p class="p22">用户在使用本网站内容时，应遵守国家法律法规和道德规范，不得将图片和视频用于非法用途或侵犯他人权益。任何未经许可的商业使用行为，将视为侵权行为，并需承担相应的法律责任。 </p>
        <p class="p22">六、法律适用与管辖 </p>
        <p class="p22">本免责声明的解释、适用及争议解决均适用中华人民共和国法律。如因使用本网站内容而引发的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向本网站所在地人民法院提起诉讼。 </p>
        <p class="p22">请您在使用本网站前仔细阅读上述免责声明，如无异议，请继续使用。如有任何疑问或建议，请随时与我们联系。我们将竭诚为您服务。 </p>
        <p class="p22"> </p>





      </div>

    </el-card>

  </div>
</template>

<script>

export default {
  name: "About",
  data() {
    return {
      form: {},
      message:'',
      allmessages:[]
    }
  },
  created() {
    this.load()
  },
  methods: {}
};
</script>

<style lang="scss">
.infinite-list-wrapper{
  width: 100%;
  height: 500px;
}
.submit-message{
  width: 100%;
  background: rgb(235, 245, 247);
  color: cadetblue;
  letter-spacing:20px;
}
@media screen and (max-width: 3000px) and (min-width: 767px) {
  .el-card-d{
    float: left;
    margin-top: 20px;
    margin-left: 10%;
    width: 80%;
    height: 90%;
  }

}
/*
屏幕小于768px的
*/
@media screen and (max-width:768px) and (min-width: 100px){
  .el-card-d{

    width: 100%;
    height: 100%;
  }
}

.home-container {
  padding-top: 0;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  width: 50%; /* 或者具体的像素值 */
}
.p {
  color: #666666;
  font-family: Serif;
  font-size: 17px;
  margin-bottom: 20px;
  padding-left: 15%;  /* 设置左内边距为父元素宽度的10% */
  padding-right: 15%; /* 设置右内边距为父元素宽度的10% */
}
.p22 {
  font-family: Serif;
  font-size: 20px;
  margin-bottom: 20px;
  padding-left: 15%;  /* 设置左内边距为父元素宽度的10% */
  padding-right: 15%; /* 设置右内边距为父元素宽度的10% */
  font-weight: bold;
  color: #666666;
}
.ttl-te {
  font-family: Serif;
  font-size: 25px;
  padding-left: 15%;
  font-weight: bold;
  color: #000000;
}
.ttl {
  font-family: serif;
  font-size: 25px;
  padding-left: 15%;

  color: #000000;
}
</style>